import { ResourceBase, Related } from '../../resource-types';
import { RawModel } from '../schema';

export interface User extends ResourceBase {
  email_address?: string;
  full_name: string;
  profile_picture?: string;
  newsletter_accepted?: boolean;
  marketing_accepted?: boolean;
  newsletter_accepted_at?: string;
  marketing_accepted_at?: string;
  otp_enabled: true;
  recovery_codes_viewed_at: string;
  provider_id: string;
  has_oauth2_provider: boolean;
  relationships: {
    original_workspace: Related<'workspace'>;
  };
}

export const user: RawModel = {
  type: 'user',
  plural: 'users',
  JSONApi: true,
  useWorker: true,
  attributes: {
    id: 'UUID',
    // display_name: 'string',
    // display_image: 'URL',
    email_address: 'string',
    full_name: 'string',
    profile_picture: 'string',
    newsletter_accepted: 'boolean',
    marketing_accepted: 'boolean',
    newsletter_accepted_at: 'date',
    marketing_accepted_at: 'date',
    provider_id: 'string',
    has_oauth2_provider: 'boolean'
  },
  relationships: {}
};
